import type {
  PublisherGameFollowersSort,
  PublisherGameFollowersSortColumn,
} from "../api/getPublisherGameFollowers";

export const PUBLISHER_GAME_FOLLOWERS_SORT_COLUMNS: readonly PublisherGameFollowersSortColumn[] = [
  "followers",
  "followers_1d",
  "followers_7d",
  "followers_30d",
] as const;

export const VALID_SORT_DIRECTIONS = ["asc", "desc"] as const;

export function parsePublisherGameFollowersSort(
  sort: string | string[] | undefined
): PublisherGameFollowersSort {
  if (!sort) return "followers:desc";
  const sortValue = Array.isArray(sort) ? sort[0] : sort;

  if (sortValue.includes(":")) {
    const [column, direction] = sortValue.split(":");
    if (
      PUBLISHER_GAME_FOLLOWERS_SORT_COLUMNS.includes(column as PublisherGameFollowersSortColumn) &&
      VALID_SORT_DIRECTIONS.includes(direction as "asc" | "desc")
    ) {
      return `${column}:${direction}` as PublisherGameFollowersSort;
    }
  }

  return "followers:desc";
}

export function parseSortParts(sort: PublisherGameFollowersSort): {
  column: PublisherGameFollowersSortColumn;
  direction: "asc" | "desc";
} {
  if (!sort) {
    return { column: "followers", direction: "desc" };
  }

  const [column, direction] = sort.split(":") as [
    PublisherGameFollowersSortColumn,
    "asc" | "desc"
  ];
  return {
    column: column || "followers",
    direction: direction || "desc",
  };
}

function getDefaultSortDirection(): "asc" | "desc" {
  return "desc";
}

export function toggleSortDirection(sort: PublisherGameFollowersSort): PublisherGameFollowersSort {
  const { column, direction } = parseSortParts(sort);
  const newDirection = direction === "asc" ? "desc" : "asc";
  return `${column}:${newDirection}` as PublisherGameFollowersSort;
}

export function createSortForColumn(
  column: PublisherGameFollowersSortColumn
): PublisherGameFollowersSort {
  return `${column}:${getDefaultSortDirection()}` as PublisherGameFollowersSort;
}

